import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
`;

export const WeatherMainContainer = styled.div`
    font-family: S-Core-Dream;
    padding-bottom: 70px;

    .titleLb {
        color: #212529;
        font-size: 24px;
        font-weight: 600;
    }

    > label {
        color: #212529;
        font-size: 24px;
        font-weight: 600;
    }

    .dayLb {
        color: #0d6efd;
        font-size: 15px;
        font-weight: 600;
        padding: 16px 16px 12px;
        margin: 0;
    }

    .reportBtn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 10px 0;
        z-index: 50;

        span {
            width: calc(100% - 32px);
            max-width: 468px;
            background: #0d6efd;
            color: #fff;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 12px;
            font-weight: 600;
            font-size: 15px;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(13,110,253,0.3);
            animation: ${fadeIn} 0.4s ease;
            transition: background 0.2s;
            &:hover { background: #0b5ed7; }
        }
    }

    .copyright {
        margin: 12px 16px;
        text-align: right;
        font-size: 12px;
        color: #adb5bd;
    }
`;
